import {Model} from 'MWC';
import {formatter} from 'MWComponents';
import {Validator} from '../../ExpressOrder/validator/validator';

const PHONE_NUMBER = 'contactPhoneNumber',
    formatsArr = {
        [PHONE_NUMBER]: '_phoneFormat'
    };

export default class extends Model {
    static fields;

    isValid = false;

    constructor(data) {
        super();
        this.initData(data);
    }

    initData(data) {
        if (data === 'tso') {
            this.fields = {
                customerName: {
                    value: '',
                    firstInput: true,
                    isValid: true,
                    errors: [],
                    validates: [Validator.isNotEmpty, Validator.isMoreTwo]
                },

                contactPhoneNumber: {
                    value: '',
                    firstInput: true,
                    isValid: true,
                    errors: [],
                    validates: [Validator.isNotEmpty, Validator.phone]
                },
                agree: {
                    value: false,
                    firstInput: true,
                    isValid: true,
                    errors: [],
                    validates: [Validator.isNotEmpty]
                },
                adress: {
                    value: '',
                    firstInput: true,
                    isValid: true,
                    errors: [],
                    validates: [Validator.isNotEmpty]
                },
                companyName: {
                    value: '',
                    firstInput: true,
                    isValid: true,
                    errors: [],
                    validates: [Validator.isNotEmpty]
                }
            };
        } else if (data === 'deposits_business' || data === 'light-house' || data === 'yuo') {
            this.fields = {
                customerName: {
                    value: '',
                    firstInput: true,
                    isValid: true,
                    errors: [],
                    validates: [Validator.isNotEmpty, Validator.isMoreTwo]
                },
                okpo: {
                    value: '',
                    firstInput: true,
                    isValid: true,
                    errors: [],
                    validates: [Validator.isNotEmpty, Validator.isNumber]
                },
                contactPhoneNumber: {
                    value: '',
                    firstInput: true,
                    isValid: true,
                    errors: [],
                    validates: [Validator.isNotEmpty, Validator.phone]
                },
                agree: {
                    value: false,
                    firstInput: true,
                    isValid: true,
                    errors: [],
                    validates: [Validator.isNotEmpty]
                }
            };
        } else if (data === 'leasing') {
            this.fields = {
                customerName: {
                    value: '',
                    firstInput: true,
                    isValid: true,
                    errors: [],
                    validates: [Validator.isNotEmpty, Validator.isMoreTwo]
                },
                contactPhoneNumber: {
                    value: '',
                    firstInput: true,
                    isValid: true,
                    errors: [],
                    validates: [Validator.isNotEmpty, Validator.phone]
                },
                agree: {
                    value: false,
                    firstInput: true,
                    isValid: true,
                    errors: [],
                    validates: [Validator.isNotEmpty]
                },
                companyName: {
                    value: '',
                    firstInput: true,
                    isValid: true,
                    errors: [],
                    validates: [Validator.isNotEmpty]
                },
                sum: {
                    value: '',
                    firstInput: true,
                    isValid: true,
                    errors: [],
                    validates: [Validator.isNotEmpty, Validator.isNumber]
                }
            };
        } else if (data === 'esg') {
            this.fields = {
                contactPhoneNumber: {
                    value: '',
                    firstInput: true,
                    isValid: true,
                    errors: [],
                    validates: [Validator.isNotEmpty, Validator.phone]
                },
                message: {
                    value: '',
                    firstInput: true,
                    isValid: true,
                    errors: [],
                    validates: [Validator.isNotEmpty]
                },
                agree: {
                    value: false,
                    firstInput: true,
                    isValid: true,
                    errors: [],
                    validates: [Validator.isNotEmpty]
                }
            };
        } else
            this.fields = {
                customerName: {
                    value: '',
                    firstInput: true,
                    isValid: true,
                    errors: [],
                    validates: [Validator.isNotEmpty, Validator.isMoreTwo]
                },

                contactPhoneNumber: {
                    value: '',
                    firstInput: true,
                    isValid: true,
                    errors: [],
                    validates: [Validator.isNotEmpty, Validator.phone]
                },
                agree: {
                    value: false,
                    firstInput: true,
                    isValid: true,
                    errors: [],
                    validates: [Validator.isNotEmpty]
                }
            };
    }

    getField(fieldName) {
        return this.fields[fieldName];
    }

    run(data) {
        const name = data.name,
            value = formatsArr[name] ? this[formatsArr[name]](data.value) : data.value;

        this.fields[name].value = value;

        this.isValid = this.validate();
    }

    changeFirst(name) {
        this.fields[name].firstInput = false;
    }

    validate() {
        let result = true;
        // eslint-disable-next-line guard-for-in
        for (const item in this.fields) {
            Validator.validate(this.fields[item]);
            if (!this.fields[item].isValid) {
                result = false;
            }
        }

        return result;
    }

    _phoneFormat = value => {
        return formatter(value, '+{{dd}} ({{ddd}}) {{ddd}} {{dd}} {{dd}}');
    };

    _sumFormat = value => {
        return formatter(value, '{ddd} {ddd}');
    };
}
